"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HasDependentsErrorDescription = exports.DeleteMessage = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _LoadingElement = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/LoadingElement"));
var _utils = require("./utils");
var _events = require("../../analytics/events");
var _AssetsTable = _interopRequireDefault(require("../AssetsTable"));
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WarningSmallIcon = function WarningSmallIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningSmallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "modal": "DeleteAssetModal__modal__fskZE",
  "header": "DeleteAssetModal__header__YstUx",
  "body": "DeleteAssetModal__body__2lJ_d",
  "footer": "DeleteAssetModal__footer__3EAoC",
  "title": "DeleteAssetModal__title__1dr9Z",
  "text": "DeleteAssetModal__text__FGBfZ",
  "icon": "DeleteAssetModal__icon__h8VY1",
  "warning": "DeleteAssetModal__warning__F0gIV",
  "message": "DeleteAssetModal__message__3wWeG",
  "dependents": "DeleteAssetModal__dependents__3tWFG",
  "subtitle": "DeleteAssetModal__subtitle__2-sRR",
  "versions-container": "DeleteAssetModal__versions-container__1_VSg",
  "versionsContainer": "DeleteAssetModal__versions-container__1_VSg",
  "open-icon": "DeleteAssetModal__open-icon__X5xPP",
  "openIcon": "DeleteAssetModal__open-icon__X5xPP",
  "modal-lg": "DeleteAssetModal__modal-lg__-37XX",
  "modalLg": "DeleteAssetModal__modal-lg__-37XX"
}; 
require('./DeleteAssetModal.css');
var oneRemainingVersion = function oneRemainingVersion(assetVersions) {
  return assetVersions.length === 1;
};
var HasDependentsErrorDescription = exports.HasDependentsErrorDescription = function HasDependentsErrorDescription(_ref) {
  var dependents = _ref.dependents;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "warning-message",
    className: styles.warning
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.message
  }, /*#__PURE__*/_react.default.createElement("p", null, "This version is used as a dependency for other assets and cannot be deleted."), /*#__PURE__*/_react.default.createElement("p", null, "Remove the dependencies before deleting this version."))), /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dependents",
    className: styles.dependents
  }, /*#__PURE__*/_react.default.createElement(_AssetsTable.default, {
    onAssetClick: function onAssetClick() {
      return trackEvent(_events.EVENT_TYPES.ASSET_DEPENDENCY_CLICKED);
    },
    assets: dependents,
    title: "Dependent assets",
    caption: "Assets dependents",
    testId: "asset-dependents"
  })));
};
var DeleteMessage = exports.DeleteMessage = function DeleteMessage(_ref2) {
  var asset = _ref2.asset,
    assetVersions = _ref2.assetVersions,
    displayVersionAsMinor = _ref2.displayVersionAsMinor,
    config = _ref2.config;
  var isHardDelete = asset.status === 'development' || (0, _utils.isWithinDeleteTimeLimit)(asset.createdAt, config);
  var versionMessageVersion = displayVersionAsMinor ? "".concat(asset.minorVersion, ".x") : asset.version;
  function renderSoftDeleteInformation() {
    return !isHardDelete ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Within ", config.assetDeleteDaysLimit, " days you can delete an asset version, and reuse the name and version."), /*#__PURE__*/_react.default.createElement("p", null, "After ", config.assetDeleteDaysLimit, " days, you can delete an asset version, and cannot reuse the same name and version within your business group.")) : null;
  }
  function renderHardDeleteLastVersionDisclaimer() {
    return isHardDelete && oneRemainingVersion(assetVersions) ? /*#__PURE__*/_react.default.createElement("p", null, "This action will delete the asset from Exchange completely.") : null;
  }
  function renderAssetIdentifier() {
    return oneRemainingVersion(assetVersions) ? asset.name : "".concat(asset.name, " ").concat(versionMessageVersion);
  }
  return isHardDelete ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to delete", ' ', /*#__PURE__*/_react.default.createElement("strong", null, renderAssetIdentifier()), "?"), renderHardDeleteLastVersionDisclaimer()) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderSoftDeleteInformation(), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, renderAssetIdentifier()), " was created more than", ' ', config.assetDeleteDaysLimit, " days ago, delete?"));
};
var DeleteAssetModal = function DeleteAssetModal(_ref3) {
  var asset = _ref3.asset,
    assetVersions = _ref3.assetVersions,
    config = _ref3.config,
    onClose = _ref3.onClose,
    theme = _ref3.theme,
    onDelete = _ref3.onDelete,
    className = _ref3.className,
    hasDeleteError = _ref3.hasDeleteError,
    isDeletingAsset = _ref3.isDeletingAsset,
    dependents = _ref3.dependents,
    isDeleteBlocked = _ref3.isDeleteBlocked,
    renderErrorDescription = _ref3.renderErrorDescription,
    renderPreprocessingDelete = _ref3.renderPreprocessingDelete,
    renderDependents = _ref3.renderDependents,
    _ref3$isPreprocessing = _ref3.isPreprocessingDelete,
    isPreprocessingDelete = _ref3$isPreprocessing === void 0 ? false : _ref3$isPreprocessing,
    headerTitle = _ref3.headerTitle,
    displayVersionAsMinor = _ref3.displayVersionAsMinor,
    _ref3$isPortalReArchi = _ref3.isPortalReArchitectureEnabled,
    isPortalReArchitectureEnabled = _ref3$isPortalReArchi === void 0 ? false : _ref3$isPortalReArchi;
  var canDelete = !(isDeleteBlocked || hasDeleteError);
  function getHeaderTitle() {
    if (hasDeleteError) {
      return 'Unable to delete - Dependent asset';
    }
    if (headerTitle) {
      return headerTitle;
    }
    return oneRemainingVersion(assetVersions) ? 'Delete asset' : 'Delete asset version';
  }
  var handleDelete = _react.default.useCallback(function () {
    onDelete(asset);
  }, [onDelete, asset]);
  function renderBodyContent() {
    if (isPreprocessingDelete) {
      return renderPreprocessingDelete ? renderPreprocessingDelete() : /*#__PURE__*/_react.default.createElement(_LoadingElement.default, {
        testId: "loading-delete-modal",
        message: "Validating asset for deletion"
      });
    }
    if (hasDeleteError) {
      return renderDependents ? renderDependents({
        dependents: dependents
      }) : /*#__PURE__*/_react.default.createElement(HasDependentsErrorDescription, {
        dependents: dependents
      });
    }
    if (isDeleteBlocked) {
      return renderErrorDescription();
    }
    return /*#__PURE__*/_react.default.createElement(DeleteMessage, {
      config: config,
      asset: asset,
      assetVersions: assetVersions,
      displayVersionAsMinor: displayVersionAsMinor
    });
  }
  function renderFooterContent() {
    var target = oneRemainingVersion(assetVersions) ? 'asset' : 'version';
    var deleteLabel = isDeletingAsset ? "Deleting ".concat(target, " ...") : "Delete ".concat(target);
    var showCancelButton = isPreprocessingDelete || canDelete;
    var showCloseButton = !canDelete;
    var showDeleteButton = !(isPreprocessingDelete || !canDelete);
    return /*#__PURE__*/_react.default.createElement("div", null, showCancelButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      testId: "cancel-button",
      kind: "tertiary",
      onClick: onClose,
      noFill: true
    }, "Cancel") : null, showDeleteButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      testId: oneRemainingVersion(assetVersions) ? 'delete-asset-button' : 'delete-version-button',
      kind: "danger",
      onClick: handleDelete,
      isLoading: isDeletingAsset,
      noFill: true
    }, deleteLabel) : null, showCloseButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      testId: "close-button",
      kind: "tertiary",
      onClick: onClose,
      noFill: true
    }, isPortalReArchitectureEnabled ? 'Back' : 'Close') : null);
  }
  var labelId = 'delete-asset-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    testId: "delete-modal",
    theme: theme,
    renderInBody: false,
    onEsc: onClose,
    onClickOverlay: onClose,
    className: (0, _classnames.default)(styles.modal, (0, _defineProperty2.default)({}, styles.modalLg, isPortalReArchitectureEnabled), className),
    ariaLabelledBy: labelId,
    role: "alertdialog"
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    testId: "modal-header",
    className: styles.header,
    isDanger: true
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title
  }, canDelete ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(TrashIcon, null)) : null, !canDelete ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(WarningSmallIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
    id: labelId,
    className: styles.text,
    "data-test-id": "delete-asset-title"
  }, getHeaderTitle()))), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "modal-body",
    className: styles.body
  }, renderBodyContent()), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "modal-footer",
    className: styles.footer
  }, renderFooterContent()));
};
var _default = exports.default = DeleteAssetModal;
//# sourceMappingURL=DeleteAssetModal.js.map